<ng-container *transloco="let t">
    <div fxFill fxLayout="column" fxLayoutAlign="center center" class="session-expired-container">
        <div class="content-wrap" >
            <header class="payment-header" fxLayout="column" fxLayoutAlign="center center">
                <img src="/assets/images/login-logo.png" />
            </header>
            <div fxLayout="column" fxLayoutAlign="start center" class="session-info">
                <div class="icon" fxLayout="column" fxLayoutAlign="center center">
                    <mat-icon>access_time</mat-icon>
                </div>
                <h2>{{t('payment.LinkExpired')}}</h2>
                <p>{{t('payment.LinkExpiredInfo')}}</p>
            </div>
        </div>
    </div>
</ng-container>